import { getBrandId } from '~shared/utils/user';

const SKIN_PER_BRAND = {
    86: 'brand86', //US brand
};

const getSkinName = () => SKIN_PER_BRAND[getBrandId()];

export const loadSkinVariables = async () => {
    const skinName = getSkinName();
    if(skinName) {
        await import(
            /* webpackChunkName: "skins/[request]" */
            `../styles/skins/${skinName}.scss`
        );
    }
};
